import axios from "@/utils/axios";
// @ts-ignore
import queryString from "query-string";
/**
 *Basic CRUD Service
 */
export default class CrudService {
    /**
     *
     * @param options
     */
    async getOne(options) {
        let url = options.resource;
        if (options.extraPath) {
            url += "/" + options.extraPath;
        }
        if (options.params) {
            const queryBuilder = queryString.stringify(options.params);
            url += "?" + queryBuilder;
        }
        return axios.get(url);
    }
    /**
     *
     * @param options
     */
    async findOne(options) {
        let url = options.resource;
        if (options.extraPath) {
            url += "/" + options.extraPath;
        }
        if (options?.id) {
            url += "/" + options.id;
        }
        if (options.params) {
            const queryBuilder = queryString.stringify(options.params);
            url += "?" + queryBuilder;
        }
        return axios.get(url);
    }
    /**
     *
     * @param options
     */
    async filter(options) {
        return axios.post(`/${options.resource}/filter`, options.filter);
    }
    /**
     *
     * @param options
     */
    async findAll(options) {
        let url = options.resource;
        if (options.extraPath) {
            url += "/" + options.extraPath;
        }
        if (options.params) {
            const queryBuilder = queryString.stringify(options.params);
            url += "?" + queryBuilder;
        }
        return axios.get(url);
    }
    /**
     *
     * @param options
     */
    async paginate(options) {
        return axios.get(options.resource + "/" + options.params.limit + "/" + options.params.offset);
    }
    /**
     *
     * @param options
     */
    async create(options) {
        let url = options.resource;
        if (options.extraPath) {
            url += "/" + options.extraPath;
        }
        if (options.params) {
            const queryBuilder = queryString.stringify(options.params);
            url += "?" + queryBuilder;
        }
        return axios.post(url, options.data);
    }
    /**
     *
     * @param options
     */
    async update(options) {
        let url = options.resource;
        if (options.extraPath) {
            url += "/" + options.extraPath;
        }
        if (options.id) {
            url += "/" + options.id;
        }
        if (options.params) {
            const queryBuilder = queryString.stringify(options.params);
            url += "?" + queryBuilder;
        }
        return axios.put(url, options.data);
    }
    /**
     *
     * @param options
     */
    async delete(options) {
        return axios.delete(options.resource + "/" + options.id);
    }
}
